import React, { useState, useEffect } from 'react';
import {connect} from 'react-redux';

import { getURLLinkedIN, signInLinkedIN } from '../../services/login';
import {saveAuth,startGetDefaultTemplate} from '../../actions';
import authModel from '../../models/auth';
import {home_path} from '../../services/config';

import { Loading } from '../../components';

// imgs
import signInBtn from '../../assets/imgs/sign-in-LinkedIN2.png';
import logo from '../../assets/imgs/uglobally-logo.png';

import './login.css';

const Login = (props) => {
  const { location, history: { push }, login, getDefaultTemplates } = props;
  // console.log('props22',props);
  const [status, setStatus] = useState('');

  const auth=authModel();

  if(auth.isLogged()) {
    push(home_path);
  }

  useEffect(() => {
    if (location.search) {
      setStatus('loading');
      signInLinkedIN(location.search)
        .then(ret => {
          if(ret) {
            login(ret);

            getDefaultTemplates(true); // once on each login
          }
          push(home_path)
        })
        .catch(err => {
          console.error('error signInLinkedIN', err);
        });
    }
  }, [location.search]);


  const doLogin = async () => {
    setStatus('loading');
    const url = await getURLLinkedIN();
    // console.log('URL',url);
    window.location.href = url;
  }


  return (
    <div id="login">
      <Loading status={status} />
      <div className="login-left">
        <div>

          <img src={logo} alt="Welcome to uGlobally" />
          <button onClick={doLogin} type="button">
            <img src={signInBtn} alt="Sign in uGlobally" />
          </button>
        </div>
      </div>
      <div className="login-right">
        <div>
          <h2>We simplify your international expansion</h2>
          <p>Sign up and get access to exclusive tools to help you go international more effectively and with fewer risks</p>
        </div>
      </div>
    </div>
  )
}

const mapDispatch2Props = (dispatch)=>{
  return {
    login:(authData)=>dispatch(saveAuth(authData)),
    getDefaultTemplates:(renew)=>dispatch(startGetDefaultTemplate(renew)) // once on each login
  }
}

export default connect(null,mapDispatch2Props)(Login);